import React from 'react';
import appConfig from '../../appConfig';

const Footer = () => {
  return (
    <div className="footer">
      <div className="container-fluid bg-light justify-content-center">
        <div className="row">
          <div className="col">
            <p className="py-2 mt-5 text-center">{appConfig.copyright}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
